import { NgModule } from '@angular/core';

import { GetCustomRoleFromProgramRolesPipe } from './get-custom-role-from-program-roles.pipe';

@NgModule({
  declarations: [GetCustomRoleFromProgramRolesPipe],
  exports: [GetCustomRoleFromProgramRolesPipe],
})
export class GetCustomRoleFromProgramRolesPipeModule {}
